// extracted by mini-css-extract-plugin
module.exports = {"buttons":"HomeGallery_buttons__1Ppqh","button":"HomeGallery_button__2p4O6"};